import React, { PureComponent } from 'react';
import Classnames from 'classnames';
import axios from 'axios';
import './Typeahead.css';

const mod = (n, m) => (n % m + m) % m;

class Typeahead extends PureComponent {

    static defaultProps = {
        suggestions: [],
        wtRegion: 'US',
        typeaheadUrl: 'https://dpd.wisdomtree.com/api/securityfund/typeahead/',
        tabIndex: 1,
    };

    constructor(props) {
        super(props);

        this.state = {
            text: '',
            index: null,
            keyboard: false,
            expanded: false,
            counter: 0,
            latestSuggestionsRequestIndex: 0,
            suggestions: [],
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleEntitySelection = this.handleEntitySelection.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
        this.handleInputClick = this.handleInputClick.bind(this);
    }

    componentDidMount() {
        // Set focus back to search box
        this.searchBox.focus();
    }

    // Handle the user entering text
    handleUserInput(event) {
        this.setState({
            text: event.target.value,
        });

        if (event.target.value.length) {
            // Call the typeahead in DPD
            this.getSuggestions(event.target.value);
        } else {
            this.setState({
                suggestions: [],
                expanded: false,
            });
        }
    }

    // Handle the user selecting an entity
    handleEntitySelection(suggestion) {

        // Call the typeahead in DPD
        this.props.updateSelection(suggestion);

        const newSuggestions = this.state.suggestions.filter( s => s.externalID !== suggestion.externalID)

        // Update the suggestions
        this.setState({
            suggestions: newSuggestions,
            expanded: false,
            // text: '',
            index: null,
        });

        // Set focus back to search box
        this.searchBox.focus();
    }

    // Handle the user clicking into a box and select all
    handleInputFocus(event){
        event.target.select();
    }

    // Handle the user clicking into a box
    handleInputClick(event) {
        // Expand the dropdown
        this.setState({
            expanded: true,
        });
    }

    render() {

        const {
            text,
            index,
            expanded,
            suggestions,
            loading,
        } = this.state;

        const {
            placeholder,
            tabIndex
        } = this.props;

        return (
            // Add the Hotkeys component to capture key presses
            // <HotKeys keyMap={keyMap}>
                <div>
                    <div
                        className="typeahead"
                        tabIndex={tabIndex}
                        onFocus={() => {
                            window.clearTimeout(this.blurTimeout);
                            // this.focus(this._input);
                        }}
                    >
                        <div className={Classnames('input', { loading })}>
                            <input
                                autoFocus={true}
                                ref={(input) => { this.searchBox = input; }} 
                                // onMouseEnter={() => {
                                //     this.setState({ expanded: true });                                                    
                                //     }}
                                onFocus={(event) => {
                                    // if (width < 729) {
                                    //     document.getElementsByClassName("grayout")[0].classList.add("active")
                                    //     window.scrollBy(0, document.getElementsByClassName("fund-input")[0].getBoundingClientRect().top - 60);
                                    // }
                                    // window.clearTimeout(this.blurTimeout);
                                    // this.setState({ expanded: true });
                                    this.handleInputFocus(event); 
                                }}
                                onClick={this.handleInputClick}
                                // onBlur={() => {
                                //     // document.getElementsByClassName("grayout")[0].classList.remove("active")
                                //     // this.blurTimeout = window.setTimeout(() => {
                                //     //     onBlur && onBlur();
                                //     //     this.setState({ expanded: false });
                                //     // }, 1);
                                //     this.setState({ expanded: false });
                                // }}
                                type="text"
                                value={text}
                                placeholder={placeholder}
                                onChange={this.handleUserInput}
                                onKeyDown={event => {
                                    if (event.key === 'Escape') {
                                        this.setState({ text: '', suggestions: [], index: null, keyboard: false, expanded: false });
                                        // event.target.blur();
                                        // event.stopPropagation();
                                    } else if (event.key === 'ArrowDown') {
                                        this.setState({
                                            index: mod(index != null ? index + 1 : 0, suggestions.length),
                                            keyboard: true,
                                        });
                                        event.preventDefault();
                                    } else if (event.key === 'ArrowUp') {
                                        this.setState({
                                            index: mod(
                                                index != null ? index - 1 : -1,
                                                suggestions.length
                                            ),
                                            keyboard: true,
                                        });
                                        event.preventDefault();
                                    } else if (event.key === 'Enter') {
                                        if (index != null ) {
                                            this.handleEntitySelection(suggestions[index]);
                                            this.handleInputFocus(event); 
                                        } else {
                                            // this.onSelect(selections.filter(Boolean));
                                        }
                                    }
                                }}
                            />

                            {expanded && suggestions.length
                                ? <div 
                                    className="suggestions" 
                                    onMouseLeave={() => {
                                        this.setState({ expanded: false });                                                    
                                        }}
                                    >
                                    {suggestions.map((suggestion, i) => {
                                        return (
                                            <div
                                                key={i}
                                                className={Classnames('suggestion', {
                                                    selected: i === index,
                                                })}
                                                onClick={this.handleEntitySelection.bind(this, suggestion)}
                                                onMouseEnter={() => {
                                                    if (i !== index) {
                                                        this.setState({ index: i, keyboard: false });
                                                    }
                                                }}
                                                
                                            >
                                                <span className='ticker'>{suggestion.ticker}</span> {suggestion.name}
                                            </div>
                                        );
                                    })}
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </div>
        )
    }

    /// Typeahead method to get the top 15 results from DPD API
    async getSuggestions(query) {

        // requestIndex encodes the order at which queries are sent to the server in order
        // to ensure that a long-running query, whose response arrives after a more recent
        // and relevant query has completed, doesn't override the latest query results
        const requestIndex = this.state.counter;
        this.setState({
            counter: this.state.counter + 1,
            loading: true,
        });

        if (!query || query.length <= 1) {
            this.load_typeahead_state(requestIndex, query, [])
            return;
        }

        const url = this.props.typeaheadUrl;

        let params = this.props.params;

        if (params.token !== undefined) {

            const request = {
                method: 'GET',
                url: url,
                params: {
                    clientEmail: params.clientEmail,
                    q: query,
                },
                headers: {
                    Authorization: params.token &&
                        `Token ${params.token}`,
                },
            };
            return axios(request)
                .then((response) => {
                    if (response.status === 200) {
                        this.load_typeahead_state(requestIndex, query, Array.isArray(response.data) ? response.data : []);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.load_typeahead_state(requestIndex, query, [])
                });

        }

    };

    // Update local state with typeahead data
    load_typeahead_state(requestIndex, query, payload) {

        // Reject suggestions that aren't relevant by checking requestIndex, which would indicate
        // whether a more recent set of suggestions was already loaded
        if (requestIndex < this.state.latestSuggestionsRequestIndex) {
            return;
        }

        if (payload === undefined || payload.length === 0) {
            return;
        }

        // Make a copy of the suggestions payload
        var copy = [];

        // Get the current entity IDs of entities that may be being edited
        var fundsToCompare = this.props.currentSelection ? this.props.currentSelection : [];

        payload.forEach((item, index) => {

            // Check if a typeahead result is already being analyzed. Uses externalID
            // as the lookup
            var alreadyInList = fundsToCompare.find(function (fund) {
                return fund.externalID === item.externalID;
            });

            if (alreadyInList === undefined) {
                copy.push(item);
            }

        });

        // Update state with updated typeahead results
        this.setState({
            suggestions: copy,
            latestSuggestionsRequestIndex: requestIndex,
            loading: false,
            index: 0,
            expanded: true,
        })

    }

}

export default (Typeahead);


// WEBPACK FOOTER //
// ./src/components/AdvisorMode/HoldingsEditor/Typeahead/Typeahead.js